/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WorkerWithStatusDto } from './WorkerWithStatusDto';
import {
    WorkerWithStatusDtoFromJSON,
    WorkerWithStatusDtoFromJSONTyped,
    WorkerWithStatusDtoToJSON,
} from './WorkerWithStatusDto';

/**
 * 
 * @export
 * @interface WorkersDto
 */
export interface WorkersDto {
    /**
     * The workers.
     * @type {Array<WorkerWithStatusDto>}
     * @memberof WorkersDto
     */
    items: Array<WorkerWithStatusDto>;
}

/**
 * Check if a given object implements the WorkersDto interface.
 */
export function instanceOfWorkersDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function WorkersDtoFromJSON(json: any): WorkersDto {
    return WorkersDtoFromJSONTyped(json, false);
}

export function WorkersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkersDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(WorkerWithStatusDtoFromJSON)),
    };
}

export function WorkersDtoToJSON(value?: WorkersDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(WorkerWithStatusDtoToJSON)),
    };
}

